import WeatherOptionState from '../data/store/schema/WeatherOptionState';
import { getFallbackValueIfNull } from 'owa-options-core';
import weatherOptions from '../data/store/store';
import MailboxCalendarConfiguration from 'owa-service/lib/contract/MailboxCalendarConfiguration';
import { getCalendarConfiguration } from 'owa-calendar-configuration';

export default function isWeatherOptionDirty() {
    const optionState: WeatherOptionState = weatherOptions();
    const calendarConfiguration: MailboxCalendarConfiguration = getCalendarConfiguration();

    /*
     * This check is mandatory since on changing between subcategories
     * isDirty() is called for corresponding subcategory to show popup to discard or save changes.
     * So if GetMailboxCalendarConfiguration api fails this functions
     * will crash as well to avoid we need this null check.
     */
    if (!calendarConfiguration) {
        return false;
    }

    let weatherEnabled = getFallbackValueIfNull(
        optionState.weatherEnabled,
        calendarConfiguration.WeatherEnabled
    );
    let weatherUnit = getFallbackValueIfNull(
        optionState.weatherUnit,
        calendarConfiguration.WeatherUnit
    );

    // locations is an array of objects, so need to check if all items in both are the same
    let weatherLocations = getFallbackValueIfNull(
        optionState.weatherLocations,
        calendarConfiguration.WeatherLocations
    );
    let weatherLocationsIds: string[] = weatherLocations.map(location => location.LocationId);
    let configurationWeatherLocationsIds: string[] = calendarConfiguration.WeatherLocations.map(
        location => location.LocationId
    );
    let weatherLocationsDirty = !arraysEqual(weatherLocationsIds, configurationWeatherLocationsIds);

    return (
        weatherEnabled !== calendarConfiguration.WeatherEnabled ||
        weatherUnit !== calendarConfiguration.WeatherUnit ||
        weatherLocationsDirty
    );
}

function arraysEqual(a: any[], b: any[]): boolean {
    if (a === b) {
        return true;
    }
    if (a == null || b == null) {
        return false;
    }
    if (a.length != b.length) {
        return false;
    }
    for (var i = 0; i < a.length; ++i) {
        if (a[i] !== b[i]) {
            return false;
        }
    }
    return true;
}
